import { render } from "./ed-molecule-enquiry-details.vue?vue&type=template&id=6bd5e87b"
import script from "./ed-molecule-enquiry-details.vue?vue&type=script&lang=js"
export * from "./ed-molecule-enquiry-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__